var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"md":"4"}},[_c('v-text-field',{attrs:{"label":"Site name"}}),_c('v-text-field',{attrs:{"label":"Site url"}})],1)],1),_c('v-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }